import { KeyValueTable, Price } from '@petsmart-ui/sparky';

import type { KeyValueRowProps } from './types';

export function KeyValueRow({ title, value, customValue, weight, variant, hide, ...rest }: KeyValueRowProps) {
    if (hide) {
        return null;
    }

    return (
        <KeyValueTable.Row
            data-testid="key-value-row"
            rowKey={title}
            rowValue={customValue ?? <Price values={[value]} weight={weight} variant={variant} />}
            {...rest}
        />
    );
}
